<template>
  <div class="relative">
    <p
      class="calendar-title relative underline text-sm font-normal font-[Poppins] tracking-[0.2px] text-[#6266ea] cursor-pointer">
      {{ title }}
    </p>

    <div
      class="calendar hidden hover:flex custom-shadow bg-white w-[400px] p-4 flex-col items-center absolute z-10 right-full bottom-0 rounded-lg">
      <div class="text-[#b4b4b4] mb-4">
        <span class="capitalize">{{ monthName }}, {{ year }}</span>
        <!-- <p class="text-center">
          {{ presentDays }}/{{ totalDays }}
        </p> -->
      </div>

      <table class="w-full">
        <thead>
        <tr class="w-full">
          <th
            v-for="day in daysOfWeek"
            :key="day"
            class="font-normal text-base bg-white text-center">
            {{ day }}
          </th>
        </tr>
        </thead>

        <tbody>
        <tr v-for="(week, i) in month" :key="i">
          <td v-for="(day, j) in week" :key="`${i}-${j}`" class="text-center">
            <div
              class="text-[#b4b4b4] font-medium"
              v-if="day.daynumber">
              <p>{{ day.daynumber }}</p>

              <span class="text-xl">
                <font-awesome-icon icon="fa-regular fa-circle-check" class="text-[#008000]" v-if="day.status === 1"/>
                <font-awesome-icon icon="fa-solid fa-triangle-exclamation" class="text-[#FFD700]" v-if="day.status === 2"/>
                <font-awesome-icon icon="fa-regular fa-xmark-circle" class="text-[#FF0000]" v-if="day.status === 3"/>
                <font-awesome-icon icon="fa-regular fa-circle" class="text-[#B4B4B4]" v-if="day.status === 4"/>
                  </span>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

</template>

<script>


const EMPTY_CALENDAR_DAY = 0
const NUMBER_OF_WEEK = 5
const NUMBER_OF_DAYS = 7

export default {
  data() {
    return {
      daysOfWeek: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
      month: [],
    };
  },
  props: {
    title: {
      type: String,
      required: true,
    },

    date: {
      type: Date,
      required: true,
    },

    dateStart: {
      type: String,
      required: true,
    },

    dateEnd: {
      type: String,
      required: true,
    },

    daysWeekRequired: {
      type: String,
      required: true,
    },

    frequency: {
      type: Object,
      required: true,
    },
  },

  created() {
    const dateStart = new Date(this.dateStart)
    const dateEnd = new Date(this.dateEnd)
    const requiredDays = JSON.parse(this.daysWeekRequired)
    // date object to increment from first day to last of the current month
    const countDate = new Date(this.date.getFullYear(), this.date.getMonth(), 1)
    const weekdayshortname = ['dom.', 'seg.', 'ter.', 'qua.', 'qui.', 'sex.', 'sáb.']
    const offsetFisrtDay = weekdayshortname.indexOf(countDate.toLocaleDateString('pt-BR', {weekday: 'short'}))

    countDate.setDate(countDate.getDate() - offsetFisrtDay)
    const currentMonthNumber = this.date.getMonth()
    // inter in five weeks
    for (let week = 0; week < NUMBER_OF_WEEK; week++) {
      let weekrow = []
      // inter into seven day of week
      for (let dayweek = 0; dayweek < NUMBER_OF_DAYS; dayweek++) {
        const daynumber = countDate.getMonth() == currentMonthNumber ? countDate.getDate() : EMPTY_CALENDAR_DAY
        // get the index to each day to test if week_required_days include day index
        const index = weekdayshortname.indexOf(countDate.toLocaleDateString('pt-BR', {weekday: 'short'}))
        let status = 0
        const currentDateString = `${countDate.getFullYear()}-${String(countDate.getMonth() + 1).padStart(2, '0')}-${String(countDate.getDate()).padStart(2, '0')}`
        const values = this.frequency.filter(value => value.onlydate === currentDateString)

        if (dateStart <= countDate && countDate <= dateEnd) {
          const hasValues = values.length > 0;

          if (hasValues) {
            const statusList = values.map(v => v.status);
            status = statusList.includes(3) ? 3 : statusList.includes(2) ? 2 : 1;
          }

          if (!hasValues) {
            status = requiredDays.includes(index) ? 3 : 4;
          }
        }

        weekrow.push({
          daynumber,
          status,
        })
        countDate.setDate(countDate.getDate() + 1)
      }

      this.month.push(weekrow)
    }

  },

  computed: {
    monthName() {
      return this.date.toLocaleDateString('pt-BR', {month: 'long'})
    },

    year() {
      return this.date.getFullYear()
    }
  },
};
</script>

<style>

.custom-shadow {
  box-shadow: 0px 2.8px 2.2px rgba(0, 0, 0, 0.02),
  0px 6.7px 5.3px rgba(0, 0, 0, 0.028),
  0px 12.5px 10px rgba(0, 0, 0, 0.035),
  0px 22.3px 17.9px rgba(0, 0, 0, 0.042),
  0px 41.8px 33.4px rgba(0, 0, 0, 0.05),
  0px 100px 80px rgba(0, 0, 0, 0.07);
}

.calendar-title:hover + .calendar {
  display: flex;
}

</style>
